import { useState } from "react";
import { req } from "./ServerUtils";
import { SetDesignerWidget } from "./SetDesigner";
import { TextField, Button, Alert } from "@mui/material";

export function ReassignTemplates() {
    const [designer, setDesigner] = useState(null);
    const [id, setId] = useState('');
    const [severity, setSeverity] = useState('info');
    const [msg, setMsg] = useState('');

    function fetchDesigner() {
        req('/designer/html_templates').then(temp => {
           
            setDesigner(temp.designer_email)
        })
    }

    function onSave() {
        setSeverity('info');
        setMsg('Reassigning template...');
        req('/admin/html_templates', 'PUT', JSON.stringify({
            id,
            designer_email: designer
        })).then(res => {
            setSeverity('success');
            setMsg('Template reassigned successfully');
        }).catch(e => {
            setSeverity('error');
            setMsg(e.message);

        })
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
            gap: 20
        }}>
            <TextField
                fullWidth
                label="Id"
                variant="outlined"
                margin="normal"
                value={id}
                onChange={(e) => setId(e.target.value)}
            />
            <SetDesignerWidget designer={designer} setDesigner={setDesigner} />
            
            <Button style={{
                textTransform: 'none',
            }} variant="contained" onClick={fetchDesigner}>Fetch Designer</Button>

            <Button style={{
                textTransform: 'none',
            }} variant="contained" onClick={onSave}>Reassign Template</Button>

            <Alert variant="outlined" color="primary" severity={severity}>{msg}</Alert>
        </div>

    )
}